import createReducer from "../createReducer"
import {
  ActionTypes,
  MESSAGE_LIST_FAILED,
  MESSAGE_LIST_RECEIVE,
  MESSAGE_LIST_UNTIL,
  OperationMessages, UPDATE_CUR_REPORT
} from "./types"

const initState: OperationMessages = {
  operationMessages: [],
  isFetching: false,
  until: Date.now(),
  allLoaded: false,
  lenLastFetch: 0,
  isFirstFetch: false,
  status: true,
  curReportContent: '',
  links: {
    previous: '',
    next: ''
  }
}

const fetchApi = (state = initState): OperationMessages => {
  return {
    ...state,
    isFetching: true
  }
}

const receive = (state = initState, action: MESSAGE_LIST_RECEIVE) => {
  return {
    ...state,
    isFetching: false,
    ...action
  }
}

const failed = (state = initState, action: MESSAGE_LIST_FAILED) => {
  return {
    ...state,
    isFetching: false,
    status: action.status
  }
}

/** 更新until值*/
function updateUntil(state = initState, action: MESSAGE_LIST_UNTIL) {
  return {
    ...state,
    until: action.until
  }
}

function updateCurReport(state = initState, action: UPDATE_CUR_REPORT) {
  return {
    ...state,
    curReportContent: action.curReportContent
  }
}

export const operationReducer = createReducer<OperationMessages, ActionTypes>(initState, {
  MESSAGE_LIST_PENDING: fetchApi,
  MESSAGE_LIST_RECEIVE: receive,
  MESSAGE_LIST_FAILED: failed,
  MESSAGE_LIST_UNTIL: updateUntil,
  UPDATE_CUR_REPORT: updateCurReport
})
